var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paged-contact-core',{attrs:{"catId":_vm.catId,"hideAddNew":_vm.hideAddNew,"apiClient":_vm.apiClient,"skipAddress":_vm.skipAddress},on:{"onselect":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }